import React, { createContext, useContext, useState } from 'react';

const NightModeContext = createContext();
export const useNightMode = () => useContext(NightModeContext);

export const NightModeProvider = ({ children }) => {
    const [isNightMode, setIsNightMode] = useState(false);

    const toggleNightMode = () => {
        setIsNightMode(!isNightMode);
        document.body.classList.toggle('night-mode');
    };

    return (
        <NightModeContext.Provider value={{ isNightMode, toggleNightMode }}>
            {children}
        </NightModeContext.Provider>
    );
};
